import { SVLabeledText, SVButton } from '@/components/core';
import { GRID_ROW_STYLES } from '@/constants/common';
import { BrandingThemeItem } from '@/types/brandingThemes';
import { Card, Typography, Grid, Box } from '@mui/material';

type WebsiteAndEmailsViewProps = {
  brandingTheme: BrandingThemeItem;
};

export default function WebsiteAndEmailsView({
  brandingTheme,
}: WebsiteAndEmailsViewProps) {
  return (
    <Card>
      <Typography variant="h5" mb={2}>
        Website and Emails
      </Typography>
      <Grid sx={GRID_ROW_STYLES} container>
        <Grid size={{ xs: 12, md: 6 }}>
          <SVLabeledText
            label="Primary Color"
            text={brandingTheme.primaryColor}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Box
            sx={{
              width: '100%',
              height: '45px',
              backgroundColor: brandingTheme.primaryColor,
            }}
          />
        </Grid>
      </Grid>
      <Grid sx={GRID_ROW_STYLES} container>
        <Grid size={{ xs: 12, md: 6 }}>
          <SVLabeledText
            label="Secondary Color"
            text={brandingTheme.secondaryColor}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Box
            sx={{
              width: '100%',
              height: '45px',
              backgroundColor: brandingTheme.secondaryColor,
            }}
          />
        </Grid>
      </Grid>
      <Grid sx={GRID_ROW_STYLES} container>
        <Grid size={{ xs: 12, md: 6 }}>
          <SVLabeledText
            label="Font Color on Button"
            text={brandingTheme.buttonFontColor}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <SVButton
            sx={{
              backgroundColor: brandingTheme.primaryColor,
              color: brandingTheme.buttonFontColor,
            }}>
            Button Label
          </SVButton>
        </Grid>
      </Grid>
      <Grid container>
        <Grid size={{ xs: 12, md: 6 }}>
          <SVLabeledText label="General Logo" text={brandingTheme.logoUrl} />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <img style={{ maxWidth: '100%' }} src={brandingTheme.logoUrl} />
        </Grid>
      </Grid>
    </Card>
  );
}
